export default __webpack_public_path__ + "41adffa070eaa8048edf86417301ae64.svg";